import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";
import MainFooter from "../components/layout/MainFooter";
import { useAuth } from "../providers/AuthProvider";
import { Redirect } from "react-router-dom";
import { SidebarContext } from "../providers/SidebarProvider";

const MainLayout = ({ children, noNavbar, noFooter }) => {
  const { currentUser } = useAuth();
  const { isSidebarVisible } = useContext(SidebarContext);

  // const { token } = useAuth();
  return (
    <Container fluid>
      <Row>
        <MainSidebar />
        <Col
          className="main-content p-0"
          lg={isSidebarVisible ? { size: 10, offset: 2 } : { size: 12, offset: 0 }}
          md={{ size: 9, offset: 3 }}
          sm="12"
          tag="main"
          style={{ backgroundColor: "white" }}
        >
          {currentUser ?
            <>
              {!noNavbar && <MainNavbar />}
              {children}
              {!noFooter && <MainFooter />}
            </>
            :
            <Redirect to="/login" />}
        </Col>
      </Row>
    </Container>
  );
};
MainLayout.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool
};

MainLayout.defaultProps = {
  noNavbar: false,
  noFooter: false
};

export default MainLayout;
